import script from "./HomeContact.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeContact.vue?vue&type=script&lang=ts&setup=true"

import "./HomeContact.vue?vue&type=style&index=0&id=44d9c24c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d9c24c"]])

export default __exports__